module.exports = __webpack_public_path__ + "static/hero1-ff7ee138da9246f31acaed13c31151ea.jpg";